import React from 'react';
import { Sparkles, Brain } from 'lucide-react';

const AiLearningProgress = ({
  subQuestionId,
  isVisible
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="ai-learning-modal mb-3">
      <div className="ai-learning-header">
        <div className="flex items-center gap-3">
          <div className="ai-learning-icon processing">
            <Brain className="w-4 h-4" />
            <div className="learning-pulse"></div>
          </div>
          <h4 className="ai-learning-title">
            AI Learning in Progress
          </h4>
        </div>
      </div>
      <div className="ai-learning-content">
        <p className="ai-learning-description">
          GradeWiz AI is analyzing your feedback and refining its grading criteria. This process involves understanding your corrections, updating the grading rubric, and regrading all remaining submissions.
        </p>
        <div className="ai-learning-progress-container">
          <div className="ai-learning-progress-bar">
            <div className="ai-learning-progress-fill"></div>
          </div>
          <div className="ai-learning-status">
            <div className="flex items-center gap-2">
              <div className="spinner" style={{
                width: '16px',
                height: '16px',
                border: '2px solid rgba(228, 177, 122, 0.3)',
                borderRadius: '50%',
                borderTopColor: '#e4b17a'
              }}></div>
              <span className="text-sm font-medium text-gray-600">
                Learning and regrading submissions...
              </span>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .ai-learning-icon.processing {
          position: relative;
          animation: iconPulse 2s ease-in-out infinite;
        }

        .learning-pulse {
          position: absolute;
          top: -4px;
          left: -4px;
          right: -4px;
          bottom: -4px;
          border-radius: 50%;
          background: rgba(228, 177, 122, 0.2);
          animation: pulseRing 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        }

        .ai-learning-progress-container {
          margin-top: 1rem;
          padding: 1rem;
          background: rgba(228, 177, 122, 0.05);
          border-radius: 0.5rem;
          border: 1px solid rgba(228, 177, 122, 0.1);
        }

        .ai-learning-progress-bar {
          width: 100%;
          height: 4px;
          background: rgba(228, 177, 122, 0.2);
          border-radius: 2px;
          overflow: hidden;
          margin-bottom: 0.75rem;
        }

        .ai-learning-progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #e4b17a, #d9a46a);
          border-radius: 2px;
          animation: progressFill 3s ease-in-out infinite;
          box-shadow: 0 0 8px rgba(228, 177, 122, 0.4);
        }

        .ai-learning-status {
          display: flex;
          justify-content: center;
        }

        @keyframes iconPulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }

        @keyframes pulseRing {
          0% {
            transform: scale(0.8);
            opacity: 1;
          }
          100% {
            transform: scale(1.4);
            opacity: 0;
          }
        }

        @keyframes progressFill {
          0% {
            width: 0%;
            transform: translateX(-100%);
          }
          50% {
            width: 60%;
            transform: translateX(0%);
          }
          100% {
            width: 100%;
            transform: translateX(0%);
          }
        }

        .spinner {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default AiLearningProgress;